/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DashboardInputs */

const en_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboards`)
};

const nl_dashboard = /** @type {(inputs: DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboards`)
};

/**
* | output |
* | --- |
* | "Dashboards" |
*
* @param {DashboardInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const dashboard = /** @type {((inputs?: DashboardInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DashboardInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_dashboard(inputs)
	return en_dashboard(inputs)
});